define('score_bootstrap/Components/Comments',[
    "jquery",
    "knockout",
    "eventManager",
    'loglevel',
    "score_bootstrap/Models/Comments/CommentsClient",
    "score_bootstrap/Models/Comments/CommentsResult",
    "score_bootstrap/Models/Comments/CommentModel",
    "score_bootstrap/Utils/Enums"
], function (
    $,
    ko,
    eventManager,    
    log,
    CommentsClient,
    CommentsResult,
    CommentModel,
    Enums
) {
    "use strict";

    function Comments(scope, commentsUrl, postCommentUrl, isEditorEditing, stateChangeTransmitMessages, onShowMessagesPerforming, onHideMessagesPerforming, postCommentMessagesTransmitting, removeCommentMessagesTransmitting,
            componentId, pageSize, showMoreEnabled, orderByAscending, maxCommentLength, maximumCascadedReplies, userLanguage) {

        var self = this;

        this.showMessagesPerforming = onShowMessagesPerforming || [];
        this.hideMessagesPerforming = onHideMessagesPerforming || [];
        this.stateChangeTransmitMessages = stateChangeTransmitMessages || [];
        this.postCommentMessagesTransmitting = postCommentMessagesTransmitting || [];
        this.removeCommentMessagesTransmitting = removeCommentMessagesTransmitting || [];
        this.visible = ko.observable(true);
        this.userAuthenticated =  ko.observable(false);
        this.maxCommentLength = maxCommentLength;
        this.maximumCascadedReplies = maximumCascadedReplies;
        this.orderByAscending = orderByAscending;
        this.commentsClient = new CommentsClient(commentsUrl, postCommentUrl);
        this.serviceUnavailable = ko.observable(false);
        this.results = ko.observableArray([]);
        this.pageNumber = 1;
        this.pageSize = pageSize;
        this.componentId = componentId;
        this.userLanguage = userLanguage;
        this.showMoreEnabled = showMoreEnabled;
        this.id = ko.observable(0);
        this.userTimeOffset = 0;
        this.canShowMore = ko.observable(false);
        this.newCommentText = ko.observable('');
        this.editingComment = ko.observable(false).extend({ throttle: 200 });
        this.editModal = $("#editModal");
        this.deleteModal = $("#deleteModal");
        this.restoreModal = $("#restoreModal");
        this.reset = function reset(rootId) {
            if (rootId === 0) {
                self.results.removeAll();
                self.pageNumber = 1;
            } else {
                var rootCommentModel = this.findComment(this.results(), rootId);

                if (rootCommentModel) {
                    rootCommentModel.replies.removeAll();
                }
            }
        };

        this.currentCommentLength = ko.pureComputed(function () {            
            return self.maxCommentLength - self.newCommentText().length;
        }, this);

        this.currentCommentTooLong = ko.pureComputed(function () {
            var state = self.currentCommentLength() < 0;

            if (state) {
                self.submitButtonEnabled(false);
            } else {
                self.submitButtonEnabled(self.currentCommentLength() !== self.maxCommentLength);
            }

            return state;
        }, this);

        this.submitButtonEnabled = ko.observable(true);
        this.modalSubmitEnabled = ko.observable(true);

        this.commentInFocus = ko.observable(null);

        this.openEditModal = function(comment) {
            comment.newCommentText(comment.commentText());
            self.commentInFocus(comment);
        };
        this.openDeleteModal = function (comment) {
            self.commentInFocus(comment);
        }
        this.openRestoreModal = function(comment) {
            self.commentInFocus(comment);
        };

        this.cancelComment = function(comment) {
            comment.newCommentText('');
            log.debug('click cancel on comment id' + comment.id());
        };

        this.submitComment = function(comment) {
            self.editingComment(true);
            self.submitButtonEnabled(false);
            log.debug('click submit on comment id' + comment.id());
            self.commentsClient
                .postComment(
                    0, 
                    self.componentId,
                    comment.id() ? comment.newCommentText() : self.newCommentText(),
                    Date.now(),
                    comment.id(),
                    Enums.PostCommentActionEnum.Create,
                    self.userTimeOffset,
                    self.userLanguage)
                .done(function(result) {
                    if (result) {
                        self.transmitCommentPosted();
                        self.refreshToPage(1, comment.id(), result.Id, comment.showMoreEnabled);
                    }
                    self.editingComment(false);
                    self.submitButtonEnabled(true);
                    self.newCommentText('');
                    comment.newCommentText('');
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    self.submitButtonEnabled(true);
                    self.editingComment(true);
                });
        };

        this.editComment = function (comment) {
            log.debug('click remove on comment id' + comment.id());
            self.modalSubmitEnabled(false);
            self.commentsClient
                .postComment(
                    comment.id(), 
                    self.componentId,
                    comment.newCommentText(),
                    Date.now(),
                    comment.rootId,
                    Enums.PostCommentActionEnum.Edit,
                    self.userTimeOffset,
                    self.userLanguage)
                .done(function(result) {
                    if (result) {
                        self.refreshToPage(1, comment.rootId, comment.id(), comment.showMoreEnabled);
                        self.transmitCommentPosted();
                        self.editModal.modal('toggle');
                    }
                    self.modalSubmitEnabled(true);
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    self.modalSubmitEnabled(true);
                });
        };

        this.deleteComment = function(comment) {
            log.debug('click remove on comment id' + comment.id());
            self.modalSubmitEnabled(false);
            self.commentsClient
                .postComment(
                    comment.id(), 
                    self.componentId,
                    comment.commentText(),
                    Date.now(),
                    comment.rootId,
                    Enums.PostCommentActionEnum.Delete,
                    self.userTimeOffset,
                    self.userLanguage)
                .done(function(result) {
                    if (result) {
                        self.refreshToPage(1, comment.rootId, comment.id(), comment.showMoreEnabled);
                        self.transmitCommentRemoved();
                        self.deleteModal.modal('toggle');
                    }
                    self.modalSubmitEnabled(true);
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    self.modalSubmitEnabled(true);
                });
        };

        this.restoreComment = function(comment) {
            log.debug('click restore on comment id' + comment.id());
            self.modalSubmitEnabled(false);
            self.commentsClient
                .postComment(
                    comment.id(), 
                    self.componentId,
                    comment.commentText(),
                    Date.now(),
                    comment.rootId,
                    Enums.PostCommentActionEnum.Restore,
                    self.userTimeOffset,
                    self.userLanguage)
                .done(function(result) {
                    if (result) {
                        self.refreshToPage(1, comment.rootId, comment.id(), comment.showMoreEnabled);
                        self.transmitCommentPosted();
                        self.restoreModal.modal('toggle');
                    }
                    self.modalSubmitEnabled(true);
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    self.modalSubmitEnabled(true);
                });
        };

        this.loadMoreComments = function() {
            self.commentsClient
                .getComments(this.componentId,
                    this.pageNumber + 1,
                    this.pageSize,
                    this.showMoreEnabled,
                    this.orderByAscending,
                    this.maximumCascadedReplies,
                    this.userLanguage,
                    0)
                .done(this.appendComments.bind(this));
        };

        this.loadMoreReplies = function (model) {
            self.commentsClient
                .getComments(self.componentId,
                    model.pageNumber() + 1,
                    self.pageSize,
                    self.showMoreEnabled,
                    self.orderByAscending,
                    self.maximumCascadedReplies,
                    self.userLanguage,
                    model.id())
                .done(self.appendComments.bind(self));
        };

        // this stops collapsing text area in IE since IE triggers blur event after clicking on disabled button
        this.stopCollapsingIETextAreaOnDisabledButtonClick = function () {
            if (!self.submitButtonEnabled()) {
                self.editingComment(true);
                $(".score-comment-area").focus();
            }
        }

        if (!isEditorEditing) {
            self.commentsClient
                .getComments(
                    this.componentId,
                    this.pageNumber,
                    this.pageSize,
                    this.showMoreEnabled,
                    this.orderByAscending,
                    this.maximumCascadedReplies,
                    this.userLanguage,
                    0)
                .done(this.appendComments.bind(this));
        };

        if (!isEditorEditing) {
            ko.applyBindings(self, scope);
        };

        if (this.stateChangeTransmitMessages.length) {
            stateChangeTransmitMessages.forEach(function (msg) {
                eventManager.trigger(msg, self);
            });
        };

        if (this.showMessagesPerforming.length) {
            this.showMessagesPerforming.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.show, self);
            });

        };

        if (this.hideMessagesPerforming.length) {
            this.hideMessagesPerforming.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.hide, self);
            });
        };
    }

    Comments.prototype.transmitCommentPosted = function transmitCommentPosted() {
        if (this.postCommentMessagesTransmitting.length) {
            this.postCommentMessagesTransmitting.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    Comments.prototype.transmitCommentRemoved = function transmitCommentRemoved() {
        if (this.removeCommentMessagesTransmitting.length) {
            this.removeCommentMessagesTransmitting.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    Comments.prototype.show = function () {
        var self = this;

        this.visible(true);

        if (this.stateChangeTransmitMessages.length) {
            this.stateChangeTransmitMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    Comments.prototype.hide = function () {
        var self = this;

        this.visible(false);
        
        if (this.stateChangeTransmitMessages.length) {
            this.stateChangeTransmitMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }
    };

    Comments.prototype.appendComments = function appendComments(response) {

        var result = new CommentsResult(response.Comments,
            response.PageNumber,
            response.TotalNumberOfComments,
            response.NumberOfPages,
            response.RootId,
            response.ResultStatus);

        this.userTimeOffset = response.UserTimeOffset;
        this.userAuthenticated(response.UserAuthenticated);

        if (!result.resultStatus) {
            this.serviceUnavailable(true);
            this.visible(false);
        } else {
            this.serviceUnavailable(false);
            this.visible(true);
        }        

        if (result.rootId === 0) {
            if (result.pageNumber > this.pageNumber) {
                this.pageNumber = result.pageNumber;    
            }
            if (this.showMoreEnabled) {
                this.canShowMore(this.pageNumber < result.totalPages);
            }
        }

        this.insertCommentsInOrder(result);
    }

    Comments.prototype.insertCommentsInOrder = function insertCommentsInOrder(result) {

        if (result.rootId !== 0) {

            var rootCommentModel = this.findComment(this.results(), result.rootId, null);

            var targetReplies = rootCommentModel.replies;

            var resultRootComment = result.comments.filter(function(comment) {
                return comment.Id === result.rootId ? comment : null;
            });

            if (resultRootComment) {
                rootCommentModel.pageNumber(resultRootComment[0].RepliesPageNumber);
                rootCommentModel.totalPages(resultRootComment[0].TotalReplyPages);  

                resultRootComment[0].Replies.forEach(function (item) {
                    if (this.orderByAscending && !this.showMoreEnabled) {
                        targetReplies.unshift(new CommentModel(
                            rootCommentModel.id(),
                            item,
                            this.maxCommentLength,
                            false,
                            rootCommentModel.allowedCascadedReplies - 1,
                            item.RepliesPageNumber,
                            this.pageSize,
                            item.TotalReplyPages,
                            this.orderByAscending));
                    } else {
                        targetReplies.push(new CommentModel(
                            rootCommentModel.id(),
                            item,
                            this.maxCommentLength,
                            false,
                            rootCommentModel.allowedCascadedReplies - 1,
                            item.RepliesPageNumber,
                            this.pageSize,
                            item.TotalReplyPages,
                            this.orderByAscending));
                    }
                }, this);
            }
        } else {
            result.comments.forEach(function (item) {
                if (this.orderByAscending  && !this.showMoreEnabled) {
                    this.results.unshift(new CommentModel(
                        0,
                        item,
                        this.maxCommentLength,
                        this.showMoreEnabled,
                        this.maximumCascadedReplies,
                        item.RepliesPageNumber,
                        this.pageSize,
                        item.TotalReplyPages,
                        this.orderByAscending));
                } else {
                    this.results.push(new CommentModel(
                        0,
                        item,
                        this.maxCommentLength,
                        this.showMoreEnabled,
                        this.maximumCascadedReplies,
                        item.RepliesPageNumber,
                        this.pageSize,
                        item.TotalReplyPages,
                        this.orderByAscending));
                }
            }, this);
        }
    };

    Comments.prototype.refreshToPage = function refreshToPage(currentPage, rootId, commentId, showMoreEnabled) {
        var self = this;

        this.commentsClient
            .getComments(this.componentId,
                currentPage,
                this.pageSize,
                showMoreEnabled,
                this.orderByAscending,
                this.maximumCascadedReplies,
                this.userLanguage,
                rootId)
            .done(function(result) {
                self.reset(rootId);    
                self.appendComments(result);
            })
            .then(function() {
                var comment = self.findComment(self.results(), commentId, null);
                
                comment.isInFocus(true);
            });
    };

    Comments.prototype.findComment = function findComment(comments, commentId, result) {
        var self = this;

        for (var i = 0; i < comments.length; i++) {
            if (comments[i].id() === commentId) {
                result = comments[i];
                break;
            } else {
                result = self.findComment(comments[i].replies(), commentId, result);
            }
        }

        return result;
    };

    Comments.init = function init(args) { 
        return new Comments(
            args.scope,
            args.commentsUrl,
            args.postCommentUrl,
            args.IsEditorEditing,
            args.StateChangeMessagesTransmitting,
            args.ShowActionMessages,
            args.HideActionMessages,            
            args.PostCommentMessagesTransmitting,
            args.RemoveCommentMessagesTransmitting,
            args.componentId,
            args.pageSize,
            args.showMoreEnabled,
            args.orderByAscending,
            args.maxCommentLength,
            args.maximumCascadedReplies,
            args.UserLanguage);
    };

    return Comments;
});
